export const LAMBDATEST_TEST_DETAIL_LOADING = "LAMBDATEST_TEST_DETAIL_LOADING";
export const LAMBDATEST_TEST_DETAIL_SUCCESS = "LAMBDATEST_TEST_DETAIL_SUCCESS";
export const LAMBDATEST_TEST_DETAIL_FAILED = "LAMBDATEST_TEST_DETAIL_FAILED";
export const LAMBDATEST_TEST_DETAIL_CLEAR = "LAMBDATEST_TEST_DETAIL_CLEAR";

export const LAMBDATEST_TEST_DETAIL_CURRENT_FETCH =
  "LAMBDATEST_TEST_DETAIL_CURRENT_FETCH";
export const LAMBDATEST_TEST_DETAIL_SILENT_LOADING =
  "LAMBDATEST_TEST_DETAIL_SILENT_LOADING";

export const LAMBDATEST_CLEAR_BROWSER_SUBVERSION =
  "LAMBDATEST_CLEAR_BROWSER_SUBVERSION";

export const LAMBDATEST_TEST_DETAIL_HASHMAP_UPDATE =
  "LAMBDATEST_TEST_DETAIL_HASHMAP_UPDATE";
export const LAMBDATEST_PROMO_BANNER_HEIGHT = "LAMBDATEST_PROMO_BANNER_HEIGHT";

export const FETCH_SHARE_ID_DETAILS_LOADING = "FETCH_SHARE_ID_DETAILS_LOADING";
export const FETCH_SHARE_ID_DETAILS_SUCCESS = "FETCH_SHARE_ID_DETAILS_SUCCESS";
export const FETCH_SHARE_ID_DETAILS_FAILED = "FETCH_SHARE_ID_DETAILS_FAILED";
export const FETCH_FLAKY_TEST_DETAILS_LOADING =
  "FETCH_FLAKY_TEST_DETAILS_LOADING";
export const FETCH_FLAKY_TEST_DETAILS_SUCCESS =
  "FETCH_FLAKY_TEST_DETAILS_SUCCESS";
export const FETCH_FLAKY_TEST_DETAILS_FAILED =
  "FETCH_FLAKY_TEST_DETAILS_FAILED";

export const RESET_FLAKY_TEST_DETAILS = "RESET_FLAKY_TEST_DETAILS";
export const FETCH_FLAKY_GROUP_DETAILS_LOADING =
  "FETCH_FLAKY_GROUP_DETAILS_LOADING";
export const FETCH_FLAKY_GROUP_DETAILS_SILENT_LOADING =
  "FETCH_FLAKY_GROUP_DETAILS_SILENT_LOADING";
export const FETCH_FLAKY_GROUP_DETAILS_SUCCESS =
  "FETCH_FLAKY_GROUP_DETAILS_SUCCESS";
export const FETCH_FLAKY_GROUP_DETAILS_FAILED =
  "FETCH_FLAKY_GROUP_DETAILS_FAILED";
export const FLAKY_TEST_FEEDBACK = "FLAKY_TEST_FEEDBACK";
export const LAMBDATEST_REMARK_CONTAINER_HEIGHT =
  "LAMBDATEST_REMARK_CONTAINER_HEIGHT";
export const LAMBDATEST_TEST_RENAME = "LAMBDATEST_TEST_RENAME";
export const FETCH_DATA_LOCALISATION_SUCCESS =
  "FETCH_DATA_LOCALISATION_SUCCESS";
export const FETCH_DATA_LOCALISATION_FAILED = "FETCH_DATA_LOCALISATION_FAILED";
export const FETCH_DATA_LOCALISATION_LOADING =
  "FETCH_DATA_LOCALISATION_LOADING";
export const UPDATE_TEST_DETAIL_SESSION_ID = "UPDATE_TEST_DETAIL_SESSION_ID";

export const UPDATE_TEST_MUTE_STATUS_IN_TEST_DETAIL = "UPDATE_TEST_MUTE_STATUS_IN_TEST_DETAIL";